module.exports = __webpack_public_path__ + "static/media/profile.00c3813b.svg";